import React, { useEffect, useState, useRef } from 'react';
import AmazonPayDeliveryModeModal from 'components/commercetools-ui/organisms/amazonpay-checkout/components/amazonpay-deliverymode-modal';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import useLocale from 'helpers/hooks/useLocale';
import { sdk } from 'sdk';
import { AmazonPayPayload } from 'sdk/composable-commerce/types/payloads/AmazonPayPayload';
import { useCart } from 'frontastic';

const AmazonPayExpressButton = () => {
  const [signature, setSignature] = useState('');
  const [payloadJson, setPayloadJson] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const { transaction } = useCart();
  const cartAmount = CurrencyHelpers.formatMoney(transaction.total);
  const amazonHDButtonRef = useRef<HTMLDivElement>(null);
  const amazonSCButtonRef = useRef<HTMLDivElement>(null);
  const { locale } = useLocale();

  const closeModal = () => {
    setModalIsOpen(false);
  };
  const onSelectDeliveryOption = (deliveryModeId: string) => {
    let buttonRef = amazonHDButtonRef;
    if (deliveryModeId == 'StoreCollection') {
      buttonRef = amazonSCButtonRef;
    }
    if (buttonRef.current) {
      buttonRef.current.click();
    }
  };

  const showDeliveryOptions = (event: any) => {
    event.stopPropagation(); // Stop the event from propagating
    setModalIsOpen(true);
    return false;
  };

  useEffect(() => {
    const initAmazonPay = async () => {
      const payload: AmazonPayPayload = {
        webCheckoutDetails: {
          checkoutReviewReturnUrl: window.location.origin + '/en/checkout/',
          checkoutResultReturnUrl: 'https://www.example.com/result', // will be implemented later
        },
        storeId: process.env.NEXT_PUBLIC_AMAZONPAY_STORE_ID ? process.env.NEXT_PUBLIC_AMAZONPAY_STORE_ID : '',
      };

      setPayloadJson(JSON.stringify(payload));

      const res = await sdk.composableCommerce.amazon.getAmazonSignature(payload);

      setSignature(res.isError ? '' : res.data.signature);
    };

    initAmazonPay();
  }, []);

  useEffect(() => {
    const renderAmazonPayButton = (amazonPayButtonId: string, productType: string) => {
      const amazonPayButton = (window as any).amazon.Pay.renderButton(amazonPayButtonId, {
        merchantId: process.env.NEXT_PUBLIC_AMAZONPAY_MERCHAT_ID,
        publicKeyId: process.env.NEXT_PUBLIC_AMAZONPAY_PUBLIC_ID,
        ledgerCurrency: transaction.total.currencyCode,
        checkoutLanguage: locale,
        productType: productType,
        placement: 'Cart',
        buttonColor: 'Gold',
        estimatedOrderAmount: { amount: cartAmount, currencyCode: transaction.total.currencyCode },
        createCheckoutSessionConfig: {
          payloadJSON: payloadJson,
          signature: signature,
          algorithm: 'AMZN-PAY-RSASSA-PSS-V2',
        },
      });
    };

    const loadAmazonPayScript = () => {
      const script = document.createElement('script');
      script.src = 'https://static-eu.payments-amazon.com/checkout.js';
      script.async = true;
      document.body.appendChild(script);

      script.onload = () => {
        // Amazon Pay initialization
        setScriptLoaded(true);
        renderAmazonPayButton('#AmazonPayButtonHD', 'PayAndShip');
        renderAmazonPayButton('#AmazonPayButtonSC', 'PayOnly');
      };
    };

    if (signature && payloadJson && !scriptLoaded) {
      loadAmazonPayScript();
    }

    // Clean up the script when the component is unmounted
    return () => {
      const scriptElement = document.querySelector('script[src="https://static-eu.payments-amazon.com/checkout.js"]');
      if (scriptElement) {
        scriptElement.remove();
      }
    };
  }, [signature, payloadJson]);

  return (
    <>
      <div id="AmazonPayBtnContainer" className={`relative w-full  ${scriptLoaded ? '' : 'invisible'}`}>
        <div id="AmazonPayButtonHD" ref={amazonHDButtonRef} className="mx-auto h-60"></div>
        <div id="AmazonPayButtonSC" ref={amazonSCButtonRef} className="hidden"></div>
        <div
          id="AmazonPaybtnMask"
          onClick={showDeliveryOptions}
          className="absolute left-0 top-0 h-[100%] w-[100%] cursor-pointer opacity-0"
        ></div>
      </div>
      {modalIsOpen && (
        <AmazonPayDeliveryModeModal
          modalIsOpen={modalIsOpen}
          closeModal={closeModal}
          onSelectDeliveryOption={onSelectDeliveryOption}
        />
      )}
    </>
  );
};

export default AmazonPayExpressButton;
